import React, { useState, useEffect } from 'react';
import { ApiClient, AuthTokens } from '../../lib/ApiClient';
import PlaidProvider from './PlaidProvider';

interface BankProviderProps {
  apiClient: ApiClient;
  authTokens: AuthTokens | null;
  setAuthTokens: (tokens: AuthTokens | null) => void;
  simulationId: string | null;
  isConnecting: boolean;
  onSuccess: (enrollmentId: string) => void;
  onError: (error: string) => void;
  setIsLoading: (loading: boolean) => void;
}

const BankProvider: React.FC<BankProviderProps> = (props) => {
  return <PlaidProvider {...props} />;
};

export default BankProvider;